import { Injectable } from "@angular/core";
import { needsProfileCompletion } from "../helpers/profile-helper";
import { ForcedProfileCompletionModalComponent } from "../shared/modals/forced-profile-completion-modal/forced-profile-completion-modal.component";
import { LocalStorageService } from "./localStorage.service";
import {
  ModalQueuePriority,
  ModalQueueService,
} from "./modal-queue.service";

@Injectable({
  providedIn: "root",
})
export class ProfileCompletionGateService {
  private pendingGatePromise: Promise<boolean> | null = null;

  constructor(
    private modalQueue: ModalQueueService,
    private localStorageService: LocalStorageService
  ) {}

  async ensureProfileCompletionForCurrentUser(): Promise<boolean> {
    const userData = this.localStorageService.getUserData();
    if (!userData?.client || !userData?.token) {
      return true;
    }
    if (!needsProfileCompletion(userData.client)) {
      return true;
    }
    if (this.pendingGatePromise) {
      return this.pendingGatePromise;
    }

    this.pendingGatePromise = this.openForcedProfileCompletionModal();
    try {
      return await this.pendingGatePromise;
    } finally {
      this.pendingGatePromise = null;
    }
  }

  private async openForcedProfileCompletionModal(): Promise<boolean> {
    const dismissed = await this.modalQueue.enqueueModal(
      {
        component: ForcedProfileCompletionModalComponent,
        cssClass: "profile-completion-modal",
        backdropDismiss: false,
        canDismiss: async (_data, role) => role === "updated",
      },
      {
        id: "profile-completion",
        priority: ModalQueuePriority.CRITICAL,
        waitForSplashEnd: false,
        forcePresent: true,
      }
    );
    return dismissed?.role === "updated";
  }
}
